var $ = require('jquery');

$(function () {
    $('.taglinks-wrapper').each(function () {
        var tagLinksShareButton = $(this).find('.material-icons--share');
        tagLinksShareButton.on('click', function (e) {
            $(this).siblings('.copy-and-share-dropdown').toggleClass('show-share');
        });
    });
});